import { apiPath } from 'constants/api';
import type { RootState } from 'react-redux';

import { createAsyncThunk } from '@reduxjs/toolkit';
import type { ApiClient } from '@travel/api-client';
import loggerGenerator from '@travel/logger';

import type { EditProfile, UserProfile, UserProfileSns } from '../apiTypes';
import { noticeError } from '@travel/tracker';

const logger = loggerGenerator();

export const fetchUserProfile = createAsyncThunk<
  UserProfile,
  void,
  { state: RootState; extra: { apiClient: ApiClient } }
>('userProfile/fetch', async (_, { getState, extra: { apiClient }, rejectWithValue }) => {
  const {
    authCode: { item },
  } = getState();

  if (!item?.token) return;

  try {
    const data = await apiClient.get(apiPath.getUserProfile.pathname);

    return data;
  } catch (error) {
    logger.error('Error fetching user profile:', error);
    noticeError('Error fetching user profile:', error);

    return rejectWithValue(error);
  }
});
export const updateUserProfile = createAsyncThunk<
  UserProfile,
  Partial<EditProfile>,
  { extra: { apiClient: ApiClient } }
>('userProfile/update', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.patch(apiPath.getUserProfile.pathname, {
      headers: {
        'Content-Type': 'application/json',
      },
      values: payload,
    });

    return data;
  } catch (error) {
    logger.error('Error Updating user profile:', error);
    noticeError('Error Updating user profile:', error);

    return rejectWithValue(error);
  }
});

export const updateSNSData = createAsyncThunk<
  void,
  UserProfileSns[],
  { extra: { apiClient: ApiClient } }
>('sns/userList/update', async (payload, { extra: { apiClient }, rejectWithValue }) => {
  try {
    const data = await apiClient.patch(apiPath.snsList.pathname, {
      headers: {
        'Content-Type': 'application/json',
      },
      values: payload,
    });

    return data;
  } catch (error) {
    logger.error('Error Updating SNS List:', error);
    noticeError('Error Updating SNS List:', error);

    return rejectWithValue(error);
  }
});
